// ─── ПЕРЕСЕЧЕНИЕ ИГР ОДНОЙ ЛОКАЦИИ (СВЯЗКИ) ──────────────────────────────────
// 26.09 (владелец): «люди жалуются, что бронь дурки не перекрывает фазмофобию,
// хотя это связанные квесты».
//
// Проверка на сервере (conflicts.ts, linked_quest) работала ВСЕГДА: с 01.08 она
// сказала «одна локация» 25 раз, и все 25 раз сотрудник нажал «продавить». Причина
// — сетка. Автоблок связки гасил у соседа только ТОЧНО то же время: Дурка на
// нестандартные 12:30 не гасила ничего, потому что у Фазмофобии слота 12:30 нет, —
// хотя её слот 13:00 целиком внутри игры Дурки. Сетка говорила «свободно», гейт
// «нельзя», и люди верили сетке.
//
// Теперь сетка гасит соседу слоты по ПЕРЕСЕЧЕНИЮ интервалов, той же формулой, что
// гейт: [начало, начало + игра + сброс). МК вызывающий НЕ прибавляет: гейт учитывает
// МК только в филиале со сдвигом мастер-классом, и там хвост МК выражен сдвигом
// следующего слота, а не блоком. Сутки считаются от 06:00, чтобы ночные слоты (01:00)
// шли после вечерних, как везде в сетке.

const DAY_START = 6 * 60;

/** Минуты от начала суток с ночным хвостом после вечера: 01:00 → 25:00. */
export function dayMin(t: string): number {
  const [h, m] = String(t).slice(0, 5).split(":").map(Number);
  const v = (h || 0) * 60 + (m || 0);
  return v < DAY_START ? v + 1440 : v;
}

/** Пересекаются ли [a, a+aSpan) и [b, b+bSpan). Касание концами — не пересечение. */
export function spansOverlap(aStart: string, aSpan: number, bStart: string, bSpan: number): boolean {
  const a = dayMin(aStart);
  const b = dayMin(bStart);
  return a < b + bSpan && b < a + aSpan;
}

/**
 * Слоты связанного квеста, которые перекрывает игра.
 * Если длительность неизвестна (0 в справочнике) — ведём себя как раньше: гасим
 * только точное совпадение времени. Правка не должна защищать МЕНЬШЕ, чем было.
 */
export function slotsBlockedBy(start: string, span: number, slots: string[], slotSpan: number): string[] {
  if (!(span > 0) || !(slotSpan > 0)) return slots.filter((s) => s === start);
  return slots.filter((s) => spansOverlap(start, span, s, slotSpan));
}
